import React from "react";
import IconCross from "./../Icons/IconCross";
import "./Content.scss";
import Helper from "../../Helper/helper";
import VideoOverView from "../../User/Video/videoOverView";
import VideoEpisode from "../../User/Video/videoEpisode";
import VideoTrailer from "../../User/Video/videoTrailer";
import VideoMoreLikeThis from "../../User/Video/videoMoreLikeThis";
import VideoDetails from "../../User/Video/videoDetails";
import VideoCastCrew from "../../User/Video/videoCastCrew";
import ContentLoader from "../../Static/contentLoader";
import classNames from "classnames";
import { t } from "react-multi-lang";
import { resolveMediaBackground } from "../../Helper/mediaUrl";

const $ = window.$;
// const DATE_OPTIONS = {
//     year: "numeric",
//     month: "short"
// };

class Content extends Helper {
  state = {
    videoDetailsFirst: null,
    loadingFirst: true,
    videoDetailsSecond: null,
    loadingSecond: true,
    suggestion: null,
    loadingSuggestion: true,
    nav: "overview",
    overviewExpanded: false,
    inputData: {
      admin_video_id: this.props.movie.admin_video_id,
      skip: 0,
    },
  };

  showSliderContent() {
    $(".slider-content").css("display", "block");
  }

  closeSliderContent() {
    $(".slider-content").css("display", "none");
  }

  componentDidMount() {
    // Single video API call.
    // let maindata = { ...this.state.maindata };
    // let errorHandle = 0;

    this.singleVideoFirst(this.state.inputData);
  }

  componentDidUpdate(prevProps) {
    const prevId =
      prevProps.movie && prevProps.movie.admin_video_id != null
        ? prevProps.movie.admin_video_id
        : null;
    const nextId =
      this.props.movie && this.props.movie.admin_video_id != null
        ? this.props.movie.admin_video_id
        : null;
    if (prevId === nextId) {
      return;
    }

    const inputData = {
      admin_video_id: nextId,
      skip: 0,
    };
    this.setState({
      nav: "overview",
      overviewExpanded: false,
      loadingFirst: true,
      loadingSecond: true,
      inputData: inputData,
    });
    this.singleVideoFirst(inputData);
  }

  navToggle = (link, event) => {
    event.preventDefault();
    this.setState({
      nav: link,
    });
    if (link == "related") {
      if (
        localStorage.getItem("current_video_id") ==
        this.props.movie.admin_video_id
      ) {
        // Do nothing.
      } else {
        localStorage.setItem(
          "current_video_id",
          this.props.movie.admin_video_id
        );
        this.suggestion(this.state.inputData);
      }
    }
  };

  handleOverviewExpanded = (expanded) => {
    this.setState({ overviewExpanded: !!expanded });
  };

  render() {
    const movie = { ...this.props.movie };

    const {
      loadingFirst,
      videoDetailsFirst,
      videoDetailsSecond,
      loadingSecond,
      loadingSuggestion,
      suggestion,
      overviewExpanded,
    } = this.state;

    const hasTrailers =
      !loadingSecond &&
      videoDetailsSecond &&
      Array.isArray(videoDetailsSecond.trailer_section) &&
      videoDetailsSecond.trailer_section.length > 0;

    const hasCastCrew =
      !loadingFirst &&
      videoDetailsFirst &&
      Array.isArray(videoDetailsFirst.cast_crews) &&
      videoDetailsFirst.cast_crews.length > 0;

    return (
      <div
        className={classNames("content", {
          "content--overview-expanded": overviewExpanded,
        })}
      >
        <div className="content__background">
          <div className="content__background__shadow" />
          <div
            className="content__background__image"
            style={{
              backgroundImage: resolveMediaBackground(movie.default_image),
            }}
          />
        </div>
        <div className="content__area">
          <div className="content__area__container">
            {/*
              <div className="content__title">{movie.title}</div>
              <div className="content__description">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque
                et euismod ligula. Morbi mattis pretium eros, ut mollis leo tempus
                eget. Sed in dui ac ipsum feugiat ultricies. Phasellus vestibulum enim
                quis quam congue, non fringilla orci placerat. Praesent sollicitudin
              </div> 
            */}
          </div>
          <div className="slider-content-tabsec">
            <ul className="nav nav-pills" role="tablist">
              <li className="nav-item">
                <a
                  className={classNames("nav-link", {
                    active: this.state.nav == "overview",
                  })}
                  onClick={(event) => this.navToggle("overview", event)}
                  href="#"
                >
                  {t("overview")}
                </a>
              </li>
              {loadingFirst ? (
                ""
              ) : videoDetailsFirst.is_series ? (
                <li className="nav-item">
                  <a
                    className={classNames("nav-link", {
                      active: this.state.nav == "episodes",
                    })}
                    onClick={(event) => this.navToggle("episodes", event)}
                    href="#"
                  >
                    {t("episodes")}
                  </a>
                </li>
              ) : (
                ""
              )}

              {hasTrailers ? (
                    <li className="nav-item">
                      <a
                        className={classNames("nav-link", {
                          active: this.state.nav == "trailers",
                        })}
                        onClick={(event) => this.navToggle("trailers", event)}
                        href="#"
                      >
                        {t("trailer_and_more")}
                      </a>
                    </li>
                  ) : null}

              <li className="nav-item">
                <a
                  className={classNames("nav-link", {
                    active: this.state.nav == "related",
                  })}
                  onClick={(event) => this.navToggle("related", event)}
                  href="#"
                >
                  {t("more_like_this")}
                </a>
              </li>
              {hasCastCrew ? (
                <li className="nav-item">
                  <a
                    className={classNames("nav-link", {
                      active: this.state.nav == "cast",
                    })}
                    onClick={(event) => this.navToggle("cast", event)}
                    href="#"
                  >
                    {t("cast_and_crew")}
                  </a>
                </li>
              ) : null}
              <li className="nav-item">
                <a
                  className={classNames("nav-link", {
                    active: this.state.nav == "details",
                  })}
                  onClick={(event) => this.navToggle("details", event)}
                  href="#"
                >
                  {t("details")}
                </a>
              </li>
            </ul>
          </div>

          <div className="slider-content-tabcontent">
            <div className="tab-content">
              {loadingFirst ? (
                <ContentLoader />
              ) : (
                <div
                  className={classNames("tab-pane", {
                    active: this.state.nav == "overview",
                    fade: this.state.nav != "overview",
                  })}
                >
                  <VideoOverView
                    videoDetailsFirst={videoDetailsFirst}
                    onOverviewExpanded={this.handleOverviewExpanded}
                  />
                </div>
              )}

              {loadingSecond ? (
                ""
              ) : (
                <div
                  className={classNames("tab-pane", {
                    active: this.state.nav == "episodes",
                    fade: this.state.nav != "episodes",
                  })}
                >
                  <VideoEpisode
                    genreVideos={videoDetailsSecond.genre_videos}
                    genres={videoDetailsSecond.genres}
                  />
                </div>
              )}

              {hasTrailers ? (
                <div
                  className={classNames("tab-pane", {
                    active: this.state.nav == "trailers",
                    fade: this.state.nav != "trailers",
                  })}
                >
                  <VideoTrailer trailer={videoDetailsSecond.trailer_section} />
                </div>
              ) : null}

              <div
                className={classNames("tab-pane", {
                  active: this.state.nav == "related",
                  fade: this.state.nav != "related",
                })}
              >
                {loadingSuggestion ? (
                  ""
                ) : (
                  <VideoMoreLikeThis suggestion={suggestion} />
                )}
              </div>

              {hasCastCrew ? (
                <div
                  className={classNames("tab-pane", {
                    active: this.state.nav == "cast",
                    fade: this.state.nav != "cast",
                  })}
                >
                  <VideoCastCrew videoDetailsFirst={videoDetailsFirst} />
                </div>
              ) : null}

              {loadingFirst ? (
                ""
              ) : (
                <div
                  className={classNames("tab-pane", {
                    active: this.state.nav == "details",
                    fade: this.state.nav != "details",
                  })}
                >
                  <VideoDetails videoDetailsFirst={videoDetailsFirst} />
                </div>
              )}
            </div>
          </div>

          <button className="content__close" onClick={this.props.onClose}>
            <IconCross />
          </button>
        </div>
      </div>
    );
  }
}

export default Content;
